<template>
  <div>

    <el-tabs :value="activeTab" @tab-click="changeActiveTab" class="tabs">
      <el-tab-pane label="Приборы" name="devices"/>
      <el-tab-pane label="Заключение" name="conclusion"/>
    </el-tabs>

    <keep-alive v-if="showComponents">
      <device v-show="activeTab === 'devices'"/>
    </keep-alive>
    <keep-alive>
      <conclusion v-show="activeTab === 'conclusion'"/>
    </keep-alive>

    <close-visit @reload="reload"/>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex"
import Device from "@/components/visit/Device"
import Conclusion from "@/components/visit/Conclusion"
import CloseVisit from "@/components/visit/CloseVisit"

export default {
  name: "Visit.device",
  components: {Device, Conclusion, CloseVisit},
  data: function () {
    return {
      showComponents: true
    }
  },
  computed: {
    ...mapGetters("visit", {
      activeTab: "activeDeviceTab",
    }),
  },
  methods: {
    ...mapActions({
      setActiveTab: "visit/SET_ACTIVE_TAB"
    }),
    changeActiveTab(value) {
      this.setActiveTab(value.name)
    },
    reload() {
      this.showComponents = false

      this.$nextTick(() => {
        this.showComponents = true
      })
      // this.setActiveTab('conclusion')
    }
  }
}
</script>

<style scoped lang="scss">
.tabs {
  margin-top: 16px;

  /deep/ .el-tabs__item.is-active {
    color: #111;
  }

  /deep/ .el-tabs__active-bar {
    background-color: #111;
  }

  /deep/ .el-tabs__item {
    color: #8E8E93;
  }
}
</style>
